import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

import "swiper/css";
import "./Galleryy.css";

const Gallery = () => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const destinations = [
    { title: "Dubai", img: "/Images/dubai.webp" },
    { title: "Paris", img: "/Images/paris.webp" },
    { title: "Malaysia", img: "/Images/Malaysia.webp" },
    { title: "London", img: "/Images/london.webp" },
    { title: "Maldives", img: "/Images/maldives.webp" },
  ];
    const destinationsDom = [
    { title: "Riyadh", img: "/Images/Riyadh.webp"},
    { title: "Makkah", img: "/Images/Makkah.webp"},
    { title: "Jeddah", img: "/Images/Jeddah.webp"},
    { title: "AI Khobar", img: "/Images/AI-Khobar.webp"},
    { title: "Jizan", img: "/Images/Jizan.webp"},
    { title: "Tabuk", img: "/Images/Tabuk.webp"},
  ];

  return (
  <>
    <div className="destination-wrapper">
      <div className="destination-header">
        <h2>Top International getaways</h2>
        {/* <span className="view-more">View more</span> */}
      </div>

      <div className="slider-container">
        {/* LEFT ARROW */}
        <button ref={prevRef} className="slider-arrow left">‹</button>

        {/* RIGHT ARROW */}
        <button ref={nextRef} className="slider-arrow right">›</button>

        <Swiper
          modules={[Navigation]}
          spaceBetween={20}
          slidesPerView={4}
          onBeforeInit={(swiper) => {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
          }}
          navigation={{
            prevEl: prevRef.current,
            nextEl: nextRef.current,
          }}
          breakpoints={{
            0: { slidesPerView: 1.3 },
            768: { slidesPerView: 2.5 },
            1024: { slidesPerView: 4 },
          }}
        >
          {destinations.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="destination-card">
                <img src={item.img} alt={item.title} />
                <div className="destination-overlay">
                  <h4>{item.title}</h4>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>

        <div style={{marginTop:'60px'}} className="destination-wrapper">
      <div className="destination-header">
        <h2>Top domestic getaways</h2>
        {/* <span className="view-more">View more</span> */}
      </div>

      <div className="slider-container">
        {/* LEFT ARROW */}
        <button ref={prevRef} className="slider-arrow left">‹</button>

        {/* RIGHT ARROW */}
        <button ref={nextRef} className="slider-arrow right">›</button>

        <Swiper
          modules={[Navigation]}
          spaceBetween={20}
          slidesPerView={4}
          onBeforeInit={(swiper) => {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
          }}
          navigation={{
            prevEl: prevRef.current,
            nextEl: nextRef.current,
          }}
          breakpoints={{
            0: { slidesPerView: 1.3 },
            768: { slidesPerView: 2.5 },
            1024: { slidesPerView: 4 },
          }}
        >
          {destinationsDom.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="destination-card">
                <img src={item.img} alt={item.title} />
                <div className="destination-overlay">
                  <h4>{item.title}</h4>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>

  </>
  );
};

export default Gallery;
